export const REACT_APP_BASE_URL = "https://api.dismore.tech"
export const apiUrl = "https://api.dismore.tech/api/v1";

export const REACT_APP_API_URL = REACT_APP_BASE_URL + "/graphql/v1";
export const REACT_APP_API_KEY = process.env.REACT_APP_API_KEY;
